import { withInstall } from '@xzx-design/utils'
import _Upload from './src/upload'

export const Upload = withInstall(_Upload)
export default Upload

export * from './src/upload'
